var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import getTranslation from '../../../../strings/i18n';
import { getCancelPaymentAnalyticsProps } from '../../../../const/analytics/cancel-payment';
import { useActivityContext } from '../../../../context/activity-store';
import useTriggerAnalyticsEvent from '../../../../hooks/use-trigger-analytics-event';
import { StyledPrimaryButton, StyledSecondaryButton } from '../../../../styles/buttons';
import { ModalOptions } from '../../../../typings/activity/modal-types';
import { StyledModalActions } from '../../modal/subcomponents';
var closeButtonContentKey = 'common.closeButton';
var DefaultState = function (_a) {
    var handleSetCurrentModal = _a.handleSetCurrentModal, handleCloseModal = _a.handleCloseModal;
    var t = getTranslation().t;
    var isDisplayCondensed = useActivityContext().isDisplayCondensed;
    useTriggerAnalyticsEvent('cancelPayment.start');
    var primaryButtonLabel = isDisplayCondensed
        ? t('common.backButton')
        : t(closeButtonContentKey);
    return (_jsxs(_Fragment, { children: [_jsx(StyledSecondaryButton, __assign({ className: "ensightencustomevent", color: "error", onClick: function () { return handleSetCurrentModal(ModalOptions.cancelConfirm); }, uppercase: true }, getCancelPaymentAnalyticsProps('cancelPaymentCancel'), { children: t('activityDetails.cancelPayment.cancelPaymentButton') })), _jsx(StyledPrimaryButton, __assign({ className: "ensightencustomevent", onClick: handleCloseModal }, getCancelPaymentAnalyticsProps('cancelPaymentClose'), { children: primaryButtonLabel }))] }));
};
var ReviewState = function (_a) {
    var handleSetCurrentModal = _a.handleSetCurrentModal;
    var t = getTranslation().t;
    useTriggerAnalyticsEvent('cancelPayment.confirm');
    return (_jsxs(_Fragment, { children: [_jsx(StyledSecondaryButton, __assign({ className: "ensightencustomevent", onClick: function () { return handleSetCurrentModal(ModalOptions.default); }, uppercase: true }, getCancelPaymentAnalyticsProps('reviewCancelPaymentBack'), { children: t('common.backButton') })), _jsx(StyledPrimaryButton, __assign({ className: "ensightencustomevent", onClick: function () { return handleSetCurrentModal(ModalOptions.cancelInitiated); } }, getCancelPaymentAnalyticsProps('reviewCancelPaymentYes'), { children: t('activityDetails.cancelPayment.confirmCancelPaymentButton') }))] }));
};
var SuccessState = function (_a) {
    var handleCloseModal = _a.handleCloseModal;
    var t = getTranslation().t;
    useTriggerAnalyticsEvent('cancelPayment.complete');
    return (_jsx(StyledPrimaryButton, __assign({ className: "ensightencustomevent", onClick: handleCloseModal }, getCancelPaymentAnalyticsProps('cancelPaymentSuccessClose'), { children: t(closeButtonContentKey) })));
};
var ErrorState = function (_a) {
    var handleCloseModal = _a.handleCloseModal;
    var t = getTranslation().t;
    useTriggerAnalyticsEvent('cancelPayment.error');
    return (_jsx(StyledPrimaryButton, __assign({ className: "ensightencustomevent", onClick: handleCloseModal }, getCancelPaymentAnalyticsProps('cancelPaymentErrorClose'), { children: t(closeButtonContentKey) })));
};
var RenderFooter = function (_a) {
    var currentModal = _a.currentModal, handleSetCurrentModal = _a.handleSetCurrentModal, handleCloseModal = _a.handleCloseModal;
    switch (currentModal) {
        case ModalOptions.default:
            return (_jsx(DefaultState, { handleSetCurrentModal: handleSetCurrentModal, handleCloseModal: handleCloseModal }));
        case ModalOptions.cancelConfirm:
            return _jsx(ReviewState, { handleSetCurrentModal: handleSetCurrentModal });
        case ModalOptions.cancelComplete:
            return _jsx(SuccessState, { handleCloseModal: handleCloseModal });
        case ModalOptions.cancelError:
            return _jsx(ErrorState, { handleCloseModal: handleCloseModal });
        default:
            return null;
    }
};
var CancelPaymentModalFooter = function (_a) {
    var closeModal = _a.closeModal, currentModal = _a.currentModal, setCurrentModal = _a.setCurrentModal;
    var handleSetCurrentModal = function (newModalValue) {
        setTimeout(function () {
            // delay added to wait for analytics event to be send
            setCurrentModal(newModalValue);
        }, 0);
    };
    var handleCloseModal = function () {
        // delay added to wait for analytics event to be send
        setTimeout(function () {
            closeModal();
        }, 0);
    };
    return (_jsx(StyledModalActions, { justifyContent: "end", alignItems: "center", children: _jsx(RenderFooter, { currentModal: currentModal, handleSetCurrentModal: handleSetCurrentModal, handleCloseModal: handleCloseModal }) }));
};
export default CancelPaymentModalFooter;
//# sourceMappingURL=index.js.map